module.exports = __webpack_public_path__ + "static/media/fincen-gray-400x.8207dc0a.png";